import {pipe} from 'ramda';
import {createElement} from './createElement';

/**
 *
 * @param {string} htmlData
 * @returns
 */
const insertHTML = (htmlData) => {
    const div = createElement('div');

    div.insertAdjacentHTML('afterbegin', htmlData);

    return div;
}

/**
 *
 * @param {HTMLDivElement} node
 */
const getLastInsertedHTML = (node) => {
    return node.childNodes;
}

export default pipe(
    insertHTML,
    getLastInsertedHTML
);
